// @flow
/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Testimonials from "./Testimonials";

/* Render Tips app into the pug template */
function render(props) {
  // $FlowFixMe
  hydrate(<Testimonials {...props} />, document.getElementById("react"));
}

render(window.reactProps);
